import React from 'react'

import PropTypes from 'prop-types'

import styles from './component4.module.css'

const Component4 = (props) => {

  const [timerDays, setTimerDays] = React.useState("00");
  const [timerHours, setTimerHours] = React.useState("00");
  const [timerMinutes, setTimerMinutes] = React.useState("00");
  const [timerSeconds, setTimerSeconds] = React.useState("00");

  let interval = React.useRef();
  const startTimer = () => {
    const countdownDate = new Date(2025, 6, 26, 19, 30, 0).getTime();

     const intreval = setInterval(() => {
      const now = new Date().getTime();
      const distance = countdownDate - now;
      console.log('countdownDate:', countdownDate); // Debug the distance
      console.log('distance:', distance); // Debug the distance
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (distance < 0) {
        clearInterval(interval.current);
      } else {
        setTimerDays(days);
        setTimerHours(hours);
        setTimerMinutes(minutes);
        setTimerSeconds(seconds);
      }
    }, 1000);
  };

  React.useEffect(() => {
    startTimer();
    return () => {
      clearInterval(interval.current);
    };
  });

  return (
    <div className={` ${styles['container']} ${styles[props.rootClassName]} `}>
      <div className={styles['container1']}>
        <div className={styles['container2']}>
          <span className={styles['text']}>{timerDays}</span>
          <span className={styles['text01']}>Days</span>
        </div>
        <span className={styles['text02']}>:</span>
        <div className={styles['container3']}>
          <span className={styles['text03']}>{timerHours}</span>
          <span className={styles['text04']}>Hours</span>
        </div>
        <span className={styles['text05']}>:</span>
        <div className={styles['container4']}>
          <span className={styles['text06']}>{timerMinutes}</span>
          <span className={styles['text07']}>Min</span>
        </div>
        <span className={styles['text08']}>:</span>
        <div className={styles['container5']}>
          <span className={styles['text09']}>{timerSeconds}</span>
          <span className={styles['text10']}>Sec</span>
        </div>
      </div>
      {/* <div className={styles['container6']}></div> */}
    </div>
  )
}

Component4.defaultProps = {
  rootClassName: '',
}

Component4.propTypes = {
  rootClassName: PropTypes.string,
}

export default Component4
